import { createAction } from '@reduxjs/toolkit';
import { UserInfo } from 'types';

export const success = createAction('user-info/success', (data?: UserInfo) => ({
  payload: data,
}));

export default {
  success,
};
